import { Component } from '@angular/core';

@Component({
  selector: 'app-radio-waves-icon',
  templateUrl: './radio-waves-icon.component.svg',
  styleUrls: ['./radio-waves-icon.component.scss']
})
export class RadioWavesIconComponent
{

  constructor() { }

}
